<template>
  <div class="col-sm-12 list-container nopads">
    <Transition name="fade">
      <div v-if="results && results.length" class="col-sm-12">
        <div
          v-for="result of results"
          :key="result.id"
          class="data-list-item"
        >
            <div style="display: flex; width: 100%; overflow: hidden;">
                <!-- Left content: takes up available space -->
                <div style="flex: 1; padding-right: 20px; overflow: hidden; display: flex; flex-direction: column;">
                    <!-- Title with ellipsis on overflow -->
                    <span style="font-size: 1.7em; font-weight: 300; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex-grow: 1;">
                      {{ getTitle(result) }}
                    </span>

                    <!-- Status -->
                    <span class="item-text" :class="{new : result.status === 3, 'in-progress' : result.status === 2}">
                      {{ getStatusString(result.status) }}
                    </span>

                    <!-- Priority -->
                    <div class="item-text my-1">
                        {{ $t('work_assignment.select_priority') }}:
                        <span :class="{completed : result.priority_value === 1, warning : result.priority_value === 2, ban : result.priority_value === 3}">
                            {{ getPriorityString(result.priority_value) }}
                        </span>
                    </div>

                    <!-- Info -->
                    <div class="item-detail-title">
                        {{ $t('work_assignment.info') }}
                    </div>
                    <div class="item-detail-text my-2">
                        <span v-if="result.info">{{ result.info }}</span>
                        <span v-else>-</span>
                    </div>
                </div>

                <!-- Right content: fixed width, full parent height -->
                <div style="width: 13em; position: relative; top: 0; bottom: 0; display: flex; flex-direction: column;">

                    <!-- Top: Progress text, takes remaining space -->
                    <div style="flex: 1; display: flex; justify-content: center; align-items: center; font-size: 3em; font-weight: 300; color: #649601; text-align: center; white-space: nowrap;">
                        {{ `${((result.progress_value / 100) * 100).toFixed(0)} %` }}
                    </div>

                    <!-- Bottom: Buttons, fixed height -->
                    <div class="col-12 d-flex justify-content-center" style="height: 2.5em;">
                        <button
                            v-if="result.status === OPEN"
                            class="btn btn-sm btn-outline-primary form-button"
                            @click.stop="assignAssignment(result)"
                        >
                            {{ $t('work_assignment.self_assign') }}
                        </button>
                        <button
                            v-if="result.status === ASSIGNED || result.status === OPEN"
                            class="btn btn-sm btn-primary form-button"
                            @click.stop="startAssignment(result)"
                        >
                            {{ $t('work_assignment.start') }}
                        </button>
                        <button
                            v-if="result.status === ASSIGNED || result.status === IN_PROGRESS"
                            class="btn btn-sm btn-success form-button"
                            @click.stop="completeAssignment(result)"
                        >
                            {{ $t('work_assignment.ready') }}
                        </button>
                    </div>

                </div>
            </div>
            <!-- Comments-->
            <hr/>
            <comment-container
                class="mb-3"
                :topic="commentTopics.TOPIC_WORK_ASSIGNMENT"
                :id="result.id"
                :custom-api-url="workAssignmentCommentUrl"
                :user="user"
            />
        </div>
      </div>
    </Transition>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {restApi} from '../mixins/RestApiMixin'
import {workAssignmentHelper} from '../mixins/WorkAssignmentMixin'
import WorkAssignmentObservation from './WorkAssignmentObservation'
import WorkAssignmentAreaDefect from './WorkAssignmentAreaDefect'
import WorkAssignmentVehicleDefect from './WorkAssignmentVehicleDefect'
import CommentContainer from "@/components/comments/CommentContainer";
import {commentTopics} from "@/components/mixins/CommentMixin";
import {inject} from "vue";

export default {
    name: 'WorkAssignmentUserList',
    components: {CommentContainer, WorkAssignmentVehicleDefect, WorkAssignmentAreaDefect, WorkAssignmentObservation},
    mixins: [timeUtils, workAssignmentHelper, restApi],
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        },
        user: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
        }
    },
    computed: {
        commentTopics() {
            return commentTopics
        }
    },
    methods: {
        startAssignment: function (assignment) {
            this.loading = true
            this.restUpdate(this.workAssignmentStartUrl + '/' + assignment.id, {}, this.handleResponse, this.handleError)
        },
        completeAssignment: function (assignment) {
            this.loading = true
            this.restUpdate(this.workAssignmentCompleteUrl + '/' + assignment.id, {}, this.handleResponse, this.handleError)
        },
        assignAssignment: function (assignment) {
            this.loading = true
            this.restUpdate(this.workAssignmentAssignUrl + '/' + assignment.id, {}, this.handleResponse, this.handleError)
        },
        updateAssignmentProgress: function (assignment) {
            this.restUpdate(this.workAssignmentProgressUrl + assignment.id,
                {progress: assignment.progress_value}, function () {}, this.handleError)
        },
        handleResponse: function () {
            this.loading = false
            this.$emit('closeAndUpdate')
        },
        handleError: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        }
    }
}
</script>
